import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TrackingService } from '../../../services/tracking.service';
import { RenaultCampaignCrmClientEmailViewContentDTO } from 'src/app/models/renault-campaign-crm-client-dto';

@Component({  
  templateUrl: './campaign-crm-viewer.component.html',
  styleUrls: ['./campaign-crm-viewer.component.scss']
})
export class CampaignCrmViewerComponent implements OnInit {

  idClientMail: string;
  model: RenaultCampaignCrmClientEmailViewContentDTO;
  htmlPrint: SafeHtml;

  constructor(private route: ActivatedRoute,
    private service: TrackingService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.idClientMail = this.route.snapshot.paramMap.get('id');

    if (this.idClientMail !== null) {
      this.service.viewCampaignCrmEmail(this.idClientMail).subscribe(resp => {
        this.model = resp;
        this.htmlPrint = this.sanitizer.bypassSecurityTrustHtml(this.model.ContentHtml);
      });
    }

  }

}
